import React from "react";

const About = () => {
  return (
    <div className="container">
      <h1>About Page</h1>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Itaque nobis
        nisi rem vel molestiae. Deserunt eius expedita eligendi magnam dolor.
        Eveniet reprehenderit ea amet natus repudiandae repellendus commodi eum
        nisi quibusdam vel numquam, fuga saepe perferendis pariatur alias,
        maxime quasi possimus at id. Molestias consequuntur deserunt velit
        voluptatibus quasi alias ea et veniam ipsam adipisci deleniti suscipit
        nemo reprehenderit unde fuga minima est ducimus debitis itaque, qui
        libero porro! Distinctio, optio odio quibusdam aliquid nostrum
        voluptatem! Quisquam iure tenetur nesciunt neque temporibus similique,
        repudiandae delectus quaerat eos placeat earum error pariatur,
        voluptatum quas laborum suscipit, sit iste magni molestiae cum?
      </p>
    </div>
  );
};

export default About;
